import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'dashboard',
    label: 'Dashboard',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
